// File Metadata:
// Filename: DashHeader.js
// Version: 1.00
// Created: 2022-09-29 11:36:25
// Last Modified: 2025-04-01 16:55:19
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { React } from 'react'
import logo from '../logo.svg'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileCirclePlus, faFilePen } from '@fortawesome/free-solid-svg-icons'
import { AddCircle, PlaylistAddCheckCircle } from '@mui/icons-material'
import TaskIcon from '@mui/icons-material/Task'
import LocalShipping from '@mui/icons-material/LocalShipping'
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material'

import '../index.css'

import { useNavigate, Link, useLocation } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import DrawerNav from './DrawerNav'
import Button from '@mui/material/Button'

const RECEPTIONS_REGEX = /^\/dash\/receptions(\/)?$/
const SHIPMENT_REGEX = /^\/dash\/shipments(\/)?$/
const TASKBOARD_REGEX = /^\/dash\/taskboard(\/)?$/
const CROSSDOCK_REGEX = /^\/dash\/crossdock(\/)?$/

const DashHeader = () => {
	const { isVoorman, isAdmin, isAuthenticated, isManager } = useAuth() // Add auth check
	const navigate = useNavigate()
	const { pathname } = useLocation()

	const onNewShipmentClicked = () => navigate('/dash/shipments/new')
	const onShipmentsClicked = () => navigate('/dash/shipments')
	const onNewReceptionClicked = () => navigate('/dash/receptions/new')
	const onReceptionsClicked = () => navigate('/dash/receptions')
	const onTaskBoardClicked = () => navigate('dash/taskboard')
	const onCrossdockClicked = () => navigate('/dash/crossdock')

	const handleLogoClick = (e) => {
		e.preventDefault()
		navigate('/dash')
	}

	let newShipmentButton = null
	if (SHIPMENT_REGEX.test(pathname)) {
		newShipmentButton = (
			<button className='icon-button' title='Add Shipment Log' onClick={onNewShipmentClicked}>
				<AddCircle />
			</button>
		)
	}

	let shipmentButton = null
	if (!SHIPMENT_REGEX.test(pathname) && pathname.includes('/dash')) {
		shipmentButton = (
			<button className='icon-button' title='Shipment Logs' onClick={onShipmentsClicked}>
				<PlaylistAddCheckCircle />
			</button>
		)
	}

	let newReceptionButton = null
	if (RECEPTIONS_REGEX.test(pathname)) {
		newReceptionButton = (
			<button className='icon-button' title='New Reception' onClick={onNewReceptionClicked}>
				<FontAwesomeIcon icon={faFileCirclePlus} />
			</button>
		)
	}

	let receptionsButton = null
	if (!RECEPTIONS_REGEX.test(pathname) && pathname.includes('/dash')) {
		receptionsButton = (
			<button className='icon-button' title='Receptions' onClick={onReceptionsClicked}>
				<FontAwesomeIcon icon={faFilePen} />
			</button>
		)
	}

	let taskboardButton = null
	taskboardButton = (
		<button className='icon-button' title='TaskBoard' onClick={onTaskBoardClicked}>
			<TaskIcon />
		</button>
	)

	let crossdockButton = null
	if (!CROSSDOCK_REGEX.test(pathname) && pathname.includes('/dash')) {
		crossdockButton = (
			<button className='icon-button' title='Crossdock' onClick={onCrossdockClicked}>
				<LocalShipping />
			</button>
		)
	}

	let drawer = null
	if (isVoorman || isAdmin) {
		drawer = <DrawerNav />
	}

	const buttonContent = (
		<>
			{taskboardButton}
			{newShipmentButton}
			{shipmentButton}
			{newReceptionButton}
			{receptionsButton}
			{crossdockButton}
			{drawer}
		</>
	)

	const content = (
		<>
			<div className='header'>
				<div className='header__logo'>
					<Button
						onClick={handleLogoClick}
						sx={{ 
							display: 'flex',
							flexDirection: 'column',  // Stack items vertically
							alignItems: 'center',     // Center items horizontally
							textTransform: 'none',
							color: 'inherit',
							padding: '8px'            // Add some padding
						}}
					>
						<img src={logo} alt='' />
						<span className='header__message'>Inbound Dashboard</span>
					</Button>
				</div>
				<div className='header__nav'>{buttonContent}</div>
			</div>
		</>
	)

	return content
}

export default DashHeader
